/**
 * @file usePositionsState.hook.ts
 * @path apps/website/src/features/recruitment/hooks/usePositionsState.hook.ts
 */
import { useState } from "react";
import { Vacancy } from "@sirbastians/types";
import { vacancies } from "@/data/vacancies";

export const usePositionsState = () => {
  const [openId, setOpenId] = useState<string | null>(vacancies[0]?.id || null);
  
  const toggleAccordion = (id: string) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return {
    vacancies,
    openId,
    toggleAccordion,
  };
};